/* ============================================================
   YSOLÉ — global interactions
   Vanilla JS, no dependencies. Restrained luxury motion.
   ============================================================ */
(function () {
  "use strict";

  var root = document.documentElement;
  var reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* ---------- Header: transparent → solid on scroll ---------- */
  var header = document.querySelector("[data-header]");
  if (header) {
    var lastY = window.scrollY;
    var accum = 0;          // accumulated directional scroll (hysteresis)
    var ticking = false;
    var THRESHOLD = 60;     // must move this far in one direction before toggling
    var update = function () {
      var y = Math.max(0, window.scrollY);
      header.classList.toggle("is-scrolled", y > 24);
      var dy = y - lastY;
      // reset accumulator when direction flips
      if ((dy > 0) !== (accum > 0)) accum = 0;
      accum += dy;
      if (y < 120) {
        header.classList.remove("cats-hidden");
        accum = 0;
      } else if (accum > THRESHOLD) {
        header.classList.add("cats-hidden");    // decisive scroll down
      } else if (accum < -THRESHOLD) {
        header.classList.remove("cats-hidden");  // decisive scroll up
      }
      lastY = y;
      ticking = false;
    };
    update();
    window.addEventListener("scroll", function () {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }, { passive: true });
  }

  /* ---------- Generic drawer open/close ---------- */
  function openDrawer(drawer, overlay) {
    if (!drawer) return;
    drawer.classList.add("is-open");
    drawer.setAttribute("aria-hidden", "false");
    if (overlay) overlay.classList.add("is-open");
    document.body.style.overflow = "hidden";
    var focusable = drawer.querySelector("button, a, input, [tabindex]");
    if (focusable) focusable.focus();
  }
  function closeDrawer(drawer, overlay) {
    if (!drawer) return;
    drawer.classList.remove("is-open");
    drawer.setAttribute("aria-hidden", "true");
    if (overlay) overlay.classList.remove("is-open");
    document.body.style.overflow = "";
  }

  var overlay = document.querySelector("[data-overlay]");

  // Openers
  document.querySelectorAll("[data-drawer-open]").forEach(function (btn) {
    btn.addEventListener("click", function () {
      var target = document.querySelector(btn.getAttribute("data-drawer-open"));
      openDrawer(target, overlay);
    });
  });
  // Closers
  document.querySelectorAll("[data-drawer-close]").forEach(function (btn) {
    btn.addEventListener("click", function () {
      var d = btn.closest(".drawer");
      closeDrawer(d, overlay);
    });
  });
  if (overlay) {
    overlay.addEventListener("click", function () {
      document.querySelectorAll(".drawer.is-open").forEach(function (d) { closeDrawer(d, overlay); });
    });
  }
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") {
      document.querySelectorAll(".drawer.is-open").forEach(function (d) { closeDrawer(d, overlay); });
    }
  });

  /* ---------- Desktop nav dropdown (keyboard + click support) ---------- */
  document.querySelectorAll("[data-nav-item].has-panel").forEach(function (item) {
    var link = item.querySelector(".nav__link");
    if (!link) return;
    link.addEventListener("click", function (e) {
      // allow hover on desktop; on tap toggle
      if (window.matchMedia("(hover: none)").matches) {
        e.preventDefault();
        item.classList.toggle("is-open");
      }
    });
    item.addEventListener("keydown", function (e) {
      if (e.key === "Escape") item.classList.remove("is-open");
    });
  });

  /* ---------- Mobile nav accordion groups ---------- */
  document.querySelectorAll("[data-mnav-toggle]").forEach(function (btn) {
    btn.addEventListener("click", function () {
      var group = btn.closest(".m-nav__group");
      if (group) group.classList.toggle("is-open");
    });
  });

  /* ---------- Accordions (PDP) ---------- */
  document.querySelectorAll("[data-accordion] .accordion__trigger").forEach(function (trigger) {
    trigger.addEventListener("click", function () {
      var item = trigger.closest(".accordion__item");
      var panel = item.querySelector(".accordion__panel");
      var isOpen = item.classList.toggle("is-open");
      trigger.setAttribute("aria-expanded", isOpen ? "true" : "false");
      if (isOpen) panel.style.maxHeight = panel.scrollHeight + "px";
      else panel.style.maxHeight = 0;
    });
  });

  /* ---------- Scroll reveal ---------- */
  var revealEls = document.querySelectorAll("[data-reveal]");
  if (revealEls.length && !reduceMotion && "IntersectionObserver" in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add("is-in");
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: "0px 0px -8% 0px" });
    revealEls.forEach(function (el) { io.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add("is-in"); });
  }

  /* ---------- Quantity steppers ---------- */
  document.addEventListener("click", function (e) {
    var btn = e.target.closest("[data-qty]");
    if (!btn) return;
    var wrap = btn.closest(".qty");
    var input = wrap.querySelector("input");
    var val = parseInt(input.value, 10) || 1;
    if (btn.getAttribute("data-qty") === "up") val += 1;
    else val = Math.max(1, val - 1);
    input.value = val;
    input.dispatchEvent(new Event("change", { bubbles: true }));
  });

  /* ---------- PDP swatch selection (visual only; Shopify variant JS separate) ---------- */
  document.querySelectorAll("[data-swatches]").forEach(function (group) {
    // ensure one option is selected on load (first, or the pre-marked one)
    if (!group.querySelector(".swatch.is-active")) {
      var first = group.querySelector(".swatch");
      if (first) { first.classList.add("is-active"); first.setAttribute("aria-pressed", "true"); }
    }
    group.addEventListener("click", function (e) {
      var sw = e.target.closest(".swatch");
      if (!sw) return;
      group.querySelectorAll(".swatch").forEach(function (s) {
        s.setAttribute("aria-pressed", "false");
        s.classList.remove("is-active");
      });
      sw.setAttribute("aria-pressed", "true");
      sw.classList.add("is-active");
    });
  });

  /* ---------- Sticky Add to Bag (mobile PDP) ---------- */
  var stickyAtc = document.querySelector("[data-sticky-atc]");
  var mainAtc = document.querySelector("[data-main-atc]");
  if (stickyAtc && mainAtc && "IntersectionObserver" in window) {
    var atcIo = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        stickyAtc.classList.toggle("is-visible", !entry.isIntersecting && entry.boundingClientRect.top < 0);
      });
    }, { threshold: 0 });
    atcIo.observe(mainAtc);
  }

  /* ---------- Toast helper (exposed) ---------- */
  window.ysoleToast = function (msg) {
    var t = document.querySelector("[data-toast]");
    if (!t) return;
    t.textContent = msg;
    t.classList.add("is-visible");
    clearTimeout(t._timer);
    t._timer = setTimeout(function () { t.classList.remove("is-visible"); }, 2600);
  };

  /* ---------- Search overlay ---------- */
  var searchToggles = document.querySelectorAll("[data-search-toggle]");
  var searchOverlay = document.querySelector("[data-search-overlay]");
  if (searchToggles.length && searchOverlay) {
    searchToggles.forEach(function (btn) {
      btn.addEventListener("click", function (e) {
        e.preventDefault();
        searchOverlay.classList.toggle("is-open");
        if (searchOverlay.classList.contains("is-open")) {
          var input = searchOverlay.querySelector("input");
          if (input) setTimeout(function(){ input.focus(); }, 60);
        }
      });
    });
    searchOverlay.addEventListener("click", function (e) {
      if (e.target === searchOverlay || e.target.closest("[data-search-close]")) {
        searchOverlay.classList.remove("is-open");
      }
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") searchOverlay.classList.remove("is-open");
    });
  }

  /* ---------- Live product search (preview) ---------- */
  (function () {
    var products = window.YSOLE_PRODUCTS || [];
    var input = document.querySelector("[data-search-input]");
    var box = document.querySelector("[data-search-suggest]");
    var form = document.querySelector("[data-search-form]");
    function thumb(i){ return "img/"+i+".jpg"; }
    function render(list, q) {
      if (!box) return;
      if (!list.length) {
        box.innerHTML = '<div class="search-suggest__empty">No pieces match “'+q+'”. Try “ring”, “gold”, or “necklace”.</div>';
        return;
      }
      var html = '<div class="search-suggest__label">'+(q? "Suggestions" : "Popular right now")+'</div>';
      list.slice(0,6).forEach(function (p) {
        html += '<a class="search-hit" href="'+p.u+'">'
          + '<span class="search-hit__img"><img src="'+thumb(p.i)+'" onerror="this.onerror=null;this.src=\'img/'+p.i+'.svg\'" alt=""></span>'
          + '<span class="search-hit__name">'+p.n+'</span>'
          + '<span class="search-hit__price">'+p.p+'</span></a>';
      });
      if (q) html += '<a class="search-hit search-hit--all" href="search.html?q='+encodeURIComponent(q)+'">See all results for “'+q+'” →</a>';
      box.innerHTML = html;
    }
    function filter(q) {
      q = (q||"").trim().toLowerCase();
      if (!q) return products.slice(0,4);
      return products.filter(function (p) { return p.n.toLowerCase().indexOf(q) > -1; });
    }
    if (input) {
      input.addEventListener("input", function () { render(filter(input.value), input.value.trim()); });
      input.addEventListener("focus", function () { if(!box.innerHTML) render(filter(input.value), input.value.trim()); });
    }
    if (form) {
      form.addEventListener("submit", function (e) {
        var q = (input && input.value || "").trim();
        if (!q) { e.preventDefault(); return; }
        // let it navigate to search.html?q=... (default GET)
      });
    }
  })();

  /* ---------- Collection sort & filter (preview) ---------- */
  (function () {
    var toolbar = document.querySelector("[data-toolbar]");
    var grid = document.querySelector("[data-product-grid]");
    if (!toolbar || !grid) return;
    var cards = Array.prototype.slice.call(grid.querySelectorAll(".product-card"));
    cards.forEach(function (c, i) { c.dataset.order = i; });
    var filterSel = toolbar.querySelector("[data-filter]");
    var sortSel = toolbar.querySelector("[data-sort]");
    var countEl = toolbar.querySelector("[data-count]");
    function apply() {
      var f = filterSel ? filterSel.value : "";
      var sort = sortSel ? sortSel.value : "featured";
      var visible = 0;
      cards.forEach(function (c) {
        var mat = (c.getAttribute("data-material") || "");
        var show = !f || mat.indexOf(f) > -1;
        c.style.display = show ? "" : "none";
        if (show) visible++;
      });
      var arr = cards.slice();
      arr.sort(function (a, b) {
        if (sort === "price-asc") return parseFloat(a.dataset.price) - parseFloat(b.dataset.price);
        if (sort === "price-desc") return parseFloat(b.dataset.price) - parseFloat(a.dataset.price);
        if (sort === "name") return (a.dataset.name||"").localeCompare(b.dataset.name||"");
        return a.dataset.order - b.dataset.order;
      });
      arr.forEach(function (c) { grid.appendChild(c); });
      if (countEl) countEl.textContent = visible;
      grid.classList.add("is-rearranged");
    }
    if (filterSel) filterSel.addEventListener("change", apply);
    if (sortSel) sortSel.addEventListener("change", apply);
  })();

  /* ---------- Predictive search (Shopify) ---------- */
  (function () {
    var input = document.querySelector("[data-predictive-input]");
    var box = document.querySelector("[data-predictive-results]");
    if (!input || !box) return;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
    var timer = null;
    function esc(t){ var d=document.createElement("div"); d.textContent=t==null?"":t; return d.innerHTML; }
    function render(products, q) {
      if (!products.length) {
        box.innerHTML = '<div class="search-suggest__empty">No pieces match “' + esc(q) + '”.</div>';
        return;
      }
      var html = '<div class="search-suggest__label">Suggestions</div>';
      products.forEach(function (p) {
        var img = (p.featured_image && p.featured_image.url) ? p.featured_image.url : (p.image || "");
        var price = p.price != null ? p.price : "";
        html += '<a class="search-hit" href="' + p.url + '">'
          + '<span class="search-hit__img">' + (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') + '</span>'
          + '<span class="search-hit__name">' + esc(p.title) + '</span>'
          + '<span class="search-hit__price">' + esc(price) + '</span></a>';
      });
      html += '<a class="search-hit search-hit--all" href="' + root + 'search?q=' + encodeURIComponent(q) + '">See all results for “' + esc(q) + '” →</a>';
      box.innerHTML = html;
    }
    function query(q) {
      var url = root + "search/suggest.json?q=" + encodeURIComponent(q)
        + "&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last";
      fetch(url).then(function (r) { return r.json(); }).then(function (data) {
        var products = (data.resources && data.resources.results && data.resources.results.products) || [];
        render(products, q);
      }).catch(function () { box.innerHTML = ""; });
    }
    input.addEventListener("input", function () {
      var q = input.value.trim();
      clearTimeout(timer);
      if (q.length < 2) { box.innerHTML = ""; return; }
      timer = setTimeout(function () { query(q); }, 200);
    });
  })();

  /* ---------- Hover header to bring the folded category bar back ---------- */
  (function () {
    var hdr = document.querySelector("[data-header]");
    if (!hdr) return;
    hdr.addEventListener("mouseenter", function () { hdr.classList.add("cats-peek"); });
    hdr.addEventListener("mouseleave", function () { hdr.classList.remove("cats-peek"); });
  })();
})();
